module.exports = __webpack_public_path__ + "static/media/volar-infinite.ce0e6364.png";